import React from 'react'
import ReactTooltip from 'react-tooltip'
import PropTypes from 'prop-types'

export const UpsellTooltip = ({id, featureMessage, position = 'left' }) => (
  <ReactTooltip
    key={id}
    id={id}
    className="tooltip upsell no-bg-tooltip"
    place={position}
    effect="solid"
    clickable={true}
    delayHide={500}
    delayShow={250}
    delayUpdate={500} // allows mouse enter
    getContent={() => (
      <div className="tooltip-inner margin-btm-md">
        <p>{`${featureMessage} is available to Regrid Pro customers.`}</p>
        <a href="/plans">
          <i className="fas fa-arrow-right" />
          Upgrade to Pro
        </a>
      </div>
    )}
  />
)

UpsellTooltip.propTypes = {
  id:             PropTypes.string.isRequired,
  featureMessage: PropTypes.string,
  position:       PropTypes.string,
}